import { render, staticRenderFns } from "./jwlUndoPublish.vue?vue&type=template&id=231813a2&lang=pug&"
import script from "./jwlUndoPublish.vue?vue&type=script&lang=ts&"
export * from "./jwlUndoPublish.vue?vue&type=script&lang=ts&"
import style0 from "./jwlUndoPublish.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports